import React from 'react'
import AcademicMemberTaskListForm from '../../features/AcademicMemberTaskList/AcademicTaskList'

const AcademicMemberTaskList = () => {
    return (
        <AcademicMemberTaskListForm />
    )
}

export default AcademicMemberTaskList